import {remCalc} from '../../../_utils'

const quantitySelector = {
    QuantitySelector: {
        baseStyle: () => ({
            wrapper: {
                w: 'fit-content',
                gap: 'spacing.1.5',
                alignItems: 'center',
                py: 'spacing.2.5',
                px: 'spacing.1',
                textStyle: 'paragraphSm',
                border: '1px solid',
                borderColor: 'color.border.grey.300',
            },
            quantity: {
                textStyle: 'paragraphMd',
                minW: remCalc(10),
                textAlign: 'center',
                fontWeight: '400',
            },
        }),
    },
}

export default quantitySelector
